module.exports = __webpack_public_path__ + "b3812c4847cc07fa12ff58e66a9ec7c7.png";